import React, { useMemo } from 'react';
import { Select } from 'tea-component';
import { useIntl } from 'umi';

import { LANGUAGE_EN } from '@home/_config/config';
import { Operation } from '@dbl/core/filter';

import { NUMBER_OPERATION_OPTIONS, type IFilterOperationOption } from '@dbl/core/filter';
import type { INumberOperationSelectProps } from './types';

export { NUMBER_OPERATION_OPTIONS } from '@dbl/core/filter';
export { resolveValueOnOperationChange } from './utils';
export type {
  IFilterOperationOption,
  INumberOperationSelectProps,
} from './types';
export { Operation } from '@dbl/core/filter';

const NumberOperationSelect: React.FC<INumberOperationSelectProps> = ({
  operation,
  onChange,
  className,
  options = NUMBER_OPERATION_OPTIONS,
  appearance = 'button',
  ...restProps
}) => {
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const selectOptions = useMemo(
    () =>
      options.map(opt => ({
        value: opt.value,
        text: isEn ? opt.text_en : opt.text,
      })),
    [options, isEn],
  );

  return (
    <Select
      className={className}
      appearance={appearance}
      options={selectOptions}
      value={operation ?? Operation.Greater}
      onChange={onChange}
      matchButtonWidth
      {...restProps}
    />
  );
};

export default NumberOperationSelect;

